import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../constant/EndPoint";
import useGetHook from "../customHooks/useGetHook";
import IllustrationIcon from "../Icons/Illustration";
import { classNames, responsiveClassName } from "../utils/classNames";
import { deviceDetect, isMobile } from "react-device-detect";

const AuthLayout = () => {
  const defaultColor = "#EF0776";
  const deviceWidth = window.innerWidth;
  const { data: clientData, isLoading: isclientDataLoading } = useGetHook({
    queryKey: [`client-setting`],
    url: APIS.CLIENT_SETTING,
    params: {},
  });

  useEffect(() => {
    if (clientData) {
      document.title = clientData?.business_name;
      const favicon =
        (document.querySelector("link[rel='icon']") as HTMLLinkElement) ||
        (document.createElement("link") as HTMLLinkElement);
      favicon.rel = "icon";
      favicon.href = clientData?.favicon_icon;
      if (!document.querySelector("link[rel='icon']")) {
        document.head.appendChild(favicon);
      }
    }
  }, [clientData]);

  useEffect(() => {
    //@ts-ignore
    let backgroundColor = localStorage.getItem("primary-color", defaultColor);
    if (!backgroundColor) {
      document
        .querySelector(":root")
        //@ts-ignore
        .style.setProperty("--primary", defaultColor);
      localStorage.setItem("primary-color", defaultColor);
    } else {
      document
        .querySelector(":root")
        //@ts-ignore
        .style.setProperty("--primary", backgroundColor);
    }
  }, []);

  return (
    <>
      <div
        className={classNames(
          isMobile
            ? tw`fixed top-0 bottom-0 right-0 left-0 bg-gray-100  p-4`
            : tw`w-full grid grid-cols-2  bg-gray-100 h-screen place-items-center`
        )}
      >
        <div
          className={classNames(
            isMobile
              ? tw`hidden`
              : tw`text-[#fea9a9] grid place-items-center w-[95%] max-h-[90%] xl:w-[80%] h-max h-full xl:max-h-[75%]`
          )}
        >
          <IllustrationIcon
            primaryColor={"var(--primary)"}
            primaryLight={"var(--primary-light)"}
          />
        </div>
        <div
          className={classNames(
            isMobile
              ? tw`static shadow-2xl bg-white w-full p-4 rounded-2xl h-full grid place-items-center`
              : tw`px-12 py-4 rounded-2xl min-h-fit w-[95%] xl:h-[80%]  bg-white grid place-items-center mx-8`
          )}
        >
          <div
            className={classNames(
              isMobile
                ? tw`static   w-full p-4 rounded-2xl space-y-32 -translate-y-[40px]`
                : tw`relative w-full min-h-fit h-full flex flex-col justify-around`
            )}
          >
            <div className={tw`w-full`}>
              <p className={tw`text-left font-bold text-3xl  mb-2`}>
                Welcome to
              </p>
              {isclientDataLoading ? (
                <div className={tw`pb-14 h-24`} />
              ) : clientData?.logo ? (
                  <img
                    src={clientData?.logo}
                    alt="Company Login"
                    className={tw`max-h-[150px] py-4`}
                  />
                  
              ) : null}
            </div>
            <div
              className={tw`w-full h-fit flex-col items-center justify-center  mx-auto text-left self-start`}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
